import Component from './Component.vue'
import Selection from './Selection.vue'

export default {
  guid: '795fc26230c941cc89bc3c6eaae65e30',
  name: 'PayPal',
  component: Component,
  selection: Selection,
  externalPaymentCallback(guid) {
    const route = useRoute()
    const query = route.query

    if (query.paymentId && query.PayerID) {
      return {
        success: true,
        params: {
          paymentId: query.paymentId,
          PayerID: query.PayerID
        },
        errors: []
      }
    } else {
      return {
        success: false,
        params: null,
        errors: ['The payment was cancelled']
      }
    }
  }
}
